import personnelFA from './fa/fa.json'

const PersonnelMessages = {
  fa: { ...personnelFA },
}

export default PersonnelMessages
